import { createIcon } from '../utility/createIcon';

export const IconCall = createIcon('call');

export const IconChat = createIcon('chat');

export const IconEmail = createIcon('email');
